export const isWebView = (): boolean => {
    // window.webkit.messageHandlers가 존재하면 iOS 웹뷰
    if (window.webkit && window.webkit.messageHandlers) {
        return true;
    }
    // window.JSBridge가 존재하면 Android 웹뷰
    if (window.JSBridge && window.JSBridge) {
        return true;
    }
    return false;
};
